/**
 * @generated SignedSource<<7aa2c8ff83716fa4a58532fa636e9815>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CreateVersionPanelPreviewQuery$variables = {
  projectId?: string | null;
  templateId: string;
};
export type CreateVersionPanelPreviewQuery$data = {
  readonly viewer: {
    readonly component: string | null;
    readonly project: {
      readonly baselineTemplateVersionPreview: {
        readonly revenue: number | null;
      } | null;
    } | null;
  } | null;
};
export type CreateVersionPanelPreviewQuery = {
  variables: CreateVersionPanelPreviewQuery$variables;
  response: CreateVersionPanelPreviewQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "baseline_version_preview"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"baseline_version_preview\")"
},
v2 = [
  {
    "kind": "Variable",
    "name": "internalId",
    "variableName": "projectId"
  }
],
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "templateId",
      "variableName": "templateId"
    }
  ],
  "concreteType": "BaselineVersionSummary",
  "kind": "LinkedField",
  "name": "baselineTemplateVersionPreview",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "revenue",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateVersionPanelPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateVersionPanelPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f8e0e709fe6325dd986411a4219fcf72",
    "id": null,
    "metadata": {},
    "name": "CreateVersionPanelPreviewQuery",
    "operationKind": "query",
    "text": "query CreateVersionPanelPreviewQuery(\n  $projectId: ID\n  $templateId: ID!\n) {\n  viewer {\n    component(name: \"baseline_version_preview\")\n    project(internalId: $projectId) {\n      baselineTemplateVersionPreview(templateId: $templateId) {\n        revenue\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5987b87c6d015128aad3aa5b9a7a98c5";

export default node;
